import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const ORDER = { overdue: 0, due_today: 1, due_soon: 2, scheduled: 3 };

// Shown on the personal Dashboard ONLY when there is unfinished school work.
export default function SchoolWorkCard({ data }) {
  const { t, locale } = useI18n();
  const open = [...(data?.in_progress || []), ...(data?.due_soon || [])];
  if (!open.length) return null;
  const a = [...open].sort((x, y) => (ORDER[x.due_state] ?? 4) - (ORDER[y.due_state] ?? 4)
    || (x.status === "in_progress" ? -1 : 1) - (y.status === "in_progress" ? -1 : 1))[0];
  return (
    <Link to={`/assignment/${a.assignment_id}`} className="nb-card bg-sky/50 p-4 mb-6 flex items-center justify-between gap-3 hover:-translate-y-0.5 transition-transform" data-testid="dash-school-card">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-10 h-10 rounded-xl border-2 border-ink bg-white flex items-center justify-center shrink-0"><GraduationCap className="w-5 h-5" /></span>
        <div className="min-w-0">
          <div className="text-xs font-bold uppercase tracking-widest rtl:tracking-normal text-gray-600" data-testid="dash-school-count">{t("edu.stu.pendingCount", { count: open.length })}</div>
          <div className="font-cabinet font-bold truncate" dir="auto" data-testid="dash-school-title">{a.title}</div>
          <div className="text-xs text-gray-600 truncate">
            <bdi>{a.class_name}</bdi> · {t(`edu.stu.status.${a.status}`)}
          </div>
          {a.due_date && <div className="text-xs text-gray-600" data-testid="dash-school-due">{t("edu.stu.due", { date: new Date(a.due_date).toLocaleDateString(locale) })}</div>}
        </div>
      </div>
      <span className="nb-btn-primary py-2 px-4 text-sm shrink-0" data-testid="dash-school-continue">{a.status === "in_progress" ? t("edu.stu.continue") : t("edu.stu.start")} <ArrowRight className="w-4 h-4 rtl:rotate-180" /></span>
    </Link>
  );
}
